module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a-ch0901",
      "epub:type": "division",
      "id": "ut0a-ch09"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a-ch0901"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("US Senate, Lyman Trumbull, Freedmen’s Bureau Bill")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("December 19, 1865"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chilashvol20268#fn12",
      "id": "fn12r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12†")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Mr. TRUMBULL. I desire to give notice that I shall to-morrow, or on some early day thereafter, ask leave to introduce a bill to enlarge the powers of the Freedmen’s Bureau so as to secure freedom to all persons within the United States, and protect every individual in the full "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "29",
      "id": "p29",
      "role": "doc-pagebreak"
    }
  }), _vm._v("enjoyment of the rights of person and property and furnish him with means for their vindication. In giving this notice I desire to say that it is given in view of the adoption of the constitutional amendment abolishing slavery. Whatever diversity of opinion there may be as to the actual adoption of that amendment at this time in consequence of the abnormal condition of the Legislatures in some of the States which have ratified it, there can be no question that it will soon receive the ratification of a sufficient number of States, and probably before there will be time to take action on this bill, to place its validity beyond question. I have never doubted that, on the adoption of that amendment, it would be competent for Congress to protect every person in the United States in all the rights of person and property belonging to a free citizen; and to secure these rights is the object of the bill which I propose to introduce. I think it important that action should be taken on this subject at an early day for the purpose of quieting apprehensions in the minds of many friends of freedom lest by local legislation or a prevailing public sentiment in some of the States persons of the African race should continue to be oppressed and in fact deprived of their freedom, and for the purpose also of showing to those among whom slavery has heretofore existed that unless by local legislation they provide for the real freedom of their former slaves the Federal Government will, by virtue of its own authority, see that they are fully protected.")]), _vm._v(" "), _c('p', [_vm._v("The bill which I desire to introduce is intended to accomplish these objects. I hope there may be no necessity for enforcing such a bill in any part of the Union; but I consider that under the constitutional amendment Congress is bound to see that freedom is in fact secured to every person throughout the land; he must be fully protected in all his rights of person and of property; and any legislation or any public sentiment which deprives any human being in the land of those great rights of liberty will be in defiance of the Constitution, and if the States and local authorities, by legislation or otherwise, deny these rights, it is incumbent on us to see that they are secured.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249b32dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0019.vue
// module id = 108
// module chunks = 0